import { Button, Modal } from "react-bootstrap";
import { IQuestion } from "../../../../shared/model/IQuestions";
import { BodyModal } from "./BodyModal";

interface IProps {
  setShowModalQuestions: (data: boolean) => void;
  showModalQuestions: boolean;
  currentQuestion: IQuestion;
  getAdditionalQuestion: (data: number) => void;
  formik: any;
}
export const ModalQuestions = (props: IProps) => {
  const {
    currentQuestion,
    showModalQuestions,
    setShowModalQuestions,
    getAdditionalQuestion,
    formik,
  } = props;

  const handleChange = () => setShowModalQuestions(!showModalQuestions);
  
  return (
    <>
      <Modal
        show={true}
        onHide={handleChange}
        backdrop="static"
        centered
        className="modal-questions"
      >
        {currentQuestion && (
          <>
            <Modal.Header>Contanos más de vos:</Modal.Header>
            <Modal.Body className="modal-body-questions">
              {currentQuestion?.currentQuestion &&
                currentQuestion?.currentQuestion.question}
              <BodyModal currentQuestion={currentQuestion} formik={formik} />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleChange} className="cancel">
                Cancelar
              </Button>
              <Button
                className="save"
                onClick={() => getAdditionalQuestion(currentQuestion.next)}
                disabled={
                  !(
                    formik.values.candidateQuestionResponses[
                      currentQuestion.current
                    ]?.response !== "" ||
                    formik.values.candidateQuestionResponses[
                      currentQuestion.current
                    ]?.file !== ""
                  )
                }
              >
                {currentQuestion.current ===
                currentQuestion.numberOfQuestions - 1
                  ? "Enviar"
                  : "Responder"}
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};
